export const CONSTANTS = {
  TOKEN_KEY: 'graphcoolToken',
  GRAPHQL_URL: 'https://api.graph.cool/simple/v1/civzndke41b9c0198329zaov0'
};


// WEBPACK FOOTER //
// ./src/config/constants.js